import React from "react";
import { useState } from "@wordpress/element";
import { Dashicon } from '@wordpress/components';
import calculatorTypes from "../../../../assets/types-cal.json";

const Simple = ({ posts, typeCalc, number }) => {

    const classNameSpace = 'c-simple-cal';

    const [selectedOption, setSelectedOption] = useState('');
    const [area, setArea] = useState('');
    const [presentation, setpresentation] = useState('');
    const [rendimiento, setRendimiento] = useState('');
    const [productSelected, setproductSelected] = useState('');
    const [produtPresentation, setProdutPresentation] = useState('');
    const [showResult, setShowResult] = useState('');
    const [showCalc, setShowCalc] = useState('has-show-form');

    const calOptions = calculatorTypes.filter(e => e.value == typeCalc).map(e => e.label)[0];

    const filterProduct = (e) => {
        const productSelect = posts.filter(selected => e.target.value == selected.slug)[0];
        setSelectedOption(e.target.value);
        setproductSelected(productSelect);
        setRendimiento(productSelect.block_data[0].attrs.rendimiento);
    }

    const showResults = () => {
        setShowResult('has-show-results');
        setShowCalc('');
    }

    const backForInfo = () => {
        setShowResult('');
        setShowCalc('has-show-form');
    }

    return (
        <section className={classNameSpace + '__content'}>
            <div className={classNameSpace + '__select-product'}>
                <div className={classNameSpace + '__step-one'}>
                    <div className={classNameSpace + '__title-calc'}>
                        <h2 className={classNameSpace + '__title'}>
                            <strong className='number-step'>
                                {number ? number : '1'}
                            </strong>
                            Seleccionar producto de <br /> {calOptions}
                        </h2>
                    </div>
                    <div className={classNameSpace + '__product-selec'}>

                        <select className={classNameSpace + '__selector'}

                            value={selectedOption}
                            onChange={(e) => {
                                e.target.value != 0 ? filterProduct(e) : ''
                            }
                            }

                        >
                            <option value='0'>Selecciona un producto</option>
                            {posts.map((option) => (
                                <option key={option.ID} value={option.slug}>
                                    {option.title}
                                </option>
                            ))}
                        </select>

                    </div>
                    {productSelected != 0 &&
                        <div className={classNameSpace + '__product'}>
                            <img
                                style={{ width: "150px", height: "150px" }}
                                className={`${classNameSpace}__img ${(produtPresentation) ? 'finished' : ''}`} src={productSelected.featured_medium}
                            />
                            <h3 className={classNameSpace + '__product-title'}>
                                {productSelected.title}
                                {produtPresentation &&
                                    <>
                                        <strong className={classNameSpace + '__result-title'}>
                                            {Math.ceil((area / parseFloat(rendimiento.replace(",", "."))) / presentation)} Unidades
                                        </strong>
                                        <strong className={classNameSpace + '__result-title'}>de {produtPresentation}</strong>
                                    </>
                                }
                            </h3>
                        </div>
                    }
                </div>
            </div>
            {productSelected != 0 &&
                <div className={classNameSpace + '__select-dimenction'}>

                    <>
                        <div className={classNameSpace + '__step-two ' + showCalc}>
                            <div className={classNameSpace + '__title-calc'}>
                                <div>
                                    <h3 className={classNameSpace + '__title'}>
                                        <strong className='number-step'> {number ? number + 1 : '2'}</strong>
                                        Dimensiones y medidas
                                    </h3>
                                    <div>
                                        <h4 className={classNameSpace + '__area-title'}>Área total</h4>
                                        <div className={classNameSpace + '__area-input'}>

                                            <input
                                                className={classNameSpace + '__element area'}
                                                placeholder="Área"
                                                type="number"
                                                value={area}
                                                onChange={event => setArea(event.target.value)}
                                            />

                                            <select className={classNameSpace + '__element'}
                                                value={presentation}
                                                onChange={(e) => {
                                                    setpresentation(e.target.value);
                                                    setProdutPresentation(e.target.options[e.target.selectedIndex].text);
                                                }}
                                            >
                                                <option value='0'>Seleccionar</option>
                                                {productSelected.block_data[1].attrs.presentations.map((option) => (

                                                    <option key={option.id} value={option.value}>
                                                        {option.name}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <small className={classNameSpace + '__help'}>
                                    * Debes poner el área total en M² <br></br>
                                    * El campo permite agregar puntos y comas
                                </small>
                            </div>

                            {area && presentation && rendimiento &&
                                <div
                                    className={classNameSpace + '__btn-calcular'}
                                    onClick={showResults}
                                >
                                    <p className={classNameSpace + '__calcular-text'}>Calcular <Dashicon icon="arrow-right-alt" /></p>
                                </div>
                            }
                        </div>

                        <div className={classNameSpace + '__result ' + showResult}>
                            {area && presentation && rendimiento &&
                                <>
                                    <div className={classNameSpace + '__result-rend-flex'}>
                                        <div>
                                            <h4 className={classNameSpace + '__result-rend'}>Rendimiento</h4>
                                            <p className={classNameSpace + '__result-text'}>{rendimiento}</p>
                                            <p className={classNameSpace + '__result-text'}>
                                                {productSelected.block_data[0].attrs.rend_descripcion}
                                            </p>
                                        </div>
                                        <div>
                                            <h4 className={classNameSpace + '__result-rend'}>Área</h4>
                                            <p className={classNameSpace + '__result-text'}>{area}</p>
                                        </div>
                                    </div>
                                    <div className={classNameSpace + '__result-nota'}>
                                        <p className={classNameSpace + '__p-nota'}>
                                            Este resultado es una cantidad aproximada, de igual forma te recomendamos que vayas a una de nuestras Tiendas Pintuco, haz clic y encuentra la más cercana aqui. Si deseas más información contáctanos por el chat o escríbenos contacto
                                        </p>
                                    </div>
                                    <p className={classNameSpace + '__back-calculate'}
                                        onClick={backForInfo}
                                    ><Dashicon icon="arrow-left-alt" />Volver a Calcular</p>
                                </>
                            }
                        </div>
                    </>
                </div>
            }

        </section>
    )
}

export default Simple;